import router from './router'
import store from './store'
import { getUserInfo } from "@/plugins/webview";
router.beforeEach((to, from, next) => {
    document.title = to.meta.title ? to.meta.title : ""
    console.log('document.title', document.title)
    // 需要鉴权的页面 ,如果本地有缓存直接放行，在store写死token,h5方便调试
    const isLogin = (!store.getters.opsIsLogin || !store.getters.omsIsLogin) //判断为未登录
    console.log('isLogin',isLogin)
    if (to.meta.tokenAuth && isLogin) {
        console.log('路由攔截userinfo回调')
        getUserInfo((res) => {
            localStorage.setItem("token", res.token);
            localStorage.setItem("opsToken", res.opsToken);
            store.dispatch("Login", res);
            console.log('路由攔截userinfohuidiao',res)
            next()
        });
    } else {
        
        next()
    }
})